const SCOPE = 'notification-group';

export const PushNotificationGroupTestIds = {
  getToggleId: groupId => `${SCOPE}.toggle-${groupId}`,
};
